import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

export const ERROR_POPUP_DATA = {
  unsupportedFileFormat: {
    description: translate(T.UNSUPPORTED_FILE_FORMAT_DESCRIPTION)
  },
  default: {
    description: translate(T.SOMETHING_WENT_WRONG_LABEL)
  }
}
